<template>
  <ViewShipment />
</template>

<script>
import ViewShipment from "@/components/3pl/Operations/Consolidation/view-shipment.vue";

export default {
  components: {
    ViewShipment,
  },
};
</script>

<style></style>
